import {
  ADD_ASSOCIADO,
  REMOVE_ASSOCIADO,
  TOGGLE_DONE_ASSOCIADO,
  UPDATE_ASSOCIADO
} from './types';

const initialState = [];

export default function associadoPJReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ASSOCIADO: return [...state, action.payload];
    case REMOVE_ASSOCIADO: return action.payload;
    case TOGGLE_DONE_ASSOCIADO: return action.payload;
    case UPDATE_ASSOCIADO: return action.payload;
    default:
      return state;
  }
}

